import { FilterItemSource } from '../../../infra/FiltersViewModel'
import { action, computed } from 'mobx'
import { SelectFilter } from '../../../infra/FilterControls/Select/SelectFilter'
import { Id } from '../../../types/definitions'
import Workspace from '../../../iam/models/Workspace'
import JobManagementViewModel from '../../../jobs/views/JobManagement/JobManagementViewModel'

export class JobsTabViewModel {
  constructor(
    private _userPublicId: () => Id,
    private getWorkspaces: () => Workspace[],
    public jobManagementViewModel: JobManagementViewModel,
  ) {}

  /**
   * Activates the vm
   */
  async activate() {
    await this.jobManagementViewModel.activate()
    this.memberFilter.change([this.userPublicId])

    // because we add the current logged user selected workspace from the workspace switcher sidebar as default,
    // we need to clear the filter selected value
    this.workspacesFilter.clearValue()

    this.workspacesFilter.itemSource = FilterItemSource.static(
      this.getWorkspaces().map((w) => ({
        title: w.name,
        value: w.id,
      })),
    )
    await this.workspacesFilter.loadOptions()
  }

  /**
   * Deactivates the view model.
   */
  deactivate() {
    this.jobManagementViewModel.deactivate()
  }

  /**
   * Returns the current selected user
   */
  @computed
  get userPublicId() {
    return this._userPublicId()
  }

  /**
   * Returns member filter
   */
  @computed
  get memberFilter() {
    return this.jobManagementViewModel.searcher.filters.getFilter(
      'members',
    ) as SelectFilter<string, Id>
  }

  /**
   * Returns workspaces filter
   */
  @computed
  get workspacesFilter() {
    return this.jobManagementViewModel.searcher.filters.getFilter(
      'workspaces',
    ) as SelectFilter<string, Id>
  }

  @computed
  get isSearchFilterApplied() {
    const isSearching =
      this.jobManagementViewModel.searcher.searchText.value !== ''
    const haveFiltersApplied =
      this.jobManagementViewModel.searcher.filters.appliedFilterCount > 0

    return isSearching || haveFiltersApplied
  }

  @computed
  get shouldShowEmptyState() {
    return (
      this.jobManagementViewModel.searcher.scroller.isDone &&
      this.jobManagementViewModel.searcher.jobs.length === 0
    )
  }

  /**
   * Clears any search filters.
   */
  @action.bound
  clearFilters() {
    this.jobManagementViewModel.searcher.clearFilters()
  }
}
